import { useEffect } from "react";
import { useLocalization } from "@fluent/react";
import { useNavigate } from "react-router-dom";
import { Row, ContentCard, Button, ResponsiveFlex } from "@narmi/design_system";
import { cents } from "byzantine";
import filters from "byzantine/src/filters";
import { useIsDomesticWireDualApprovalRequired } from "byzantine/src/dbbl/businessLogic/entities/users/hooks";
import styles from "../../transfer/ach/ReceiptScreen.module.scss";
import { PAYMENT_ACTIVITY_ROUTE } from "../routes";
import { useDomesticWireImportContext } from "./DomesticWireImportContext";

const WireReceiptScreen = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const {
    csvResponse,
    parsedRows,
    validPayments,
    totalAmount,
    wireImportBatchId,
  } = useDomesticWireImportContext();
  const domesticWireDualApprovalRequired =
    useIsDomesticWireDualApprovalRequired();

  const formattedTotal = filters.currency(
    cents(Math.round(totalAmount * 100))
  );
  const totalPayments = validPayments.length;

  useEffect(() => {
    if (!parsedRows || !csvResponse) {
      navigate(`/${PAYMENT_ACTIVITY_ROUTE}/upload`, { replace: true });
    }
  }, [parsedRows, csvResponse, navigate]);

  if (!parsedRows || !csvResponse) {
    return null;
  }

  const handleClickDone = () => {
    navigate(
      wireImportBatchId
        ? `/${PAYMENT_ACTIVITY_ROUTE}/file-import/${wireImportBatchId}`
        : `/${PAYMENT_ACTIVITY_ROUTE}/file-import`
    );
  };

  const handleClickCTA = () => {
    navigate("../../");
  };

  return (
    <div className={styles.receiptContainer}>
      <ContentCard>
        <div className={styles.cardContainer}>
          <h3 className="fontColor--heading">
            {domesticWireDualApprovalRequired
              ? l10n.getString("wire-import-receipt-dual-approval-title")
              : l10n.getString("wire-import-receipt-title")}
            <i className="narmi-icon-check margin--left--xs" />
          </h3>
          <div className={styles.contentContainer}>
            <ResponsiveFlex gapSize="l">
              <Row>
                <Row.Item>
                  <p>{l10n.getString("wire-review-sending-label")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{formattedTotal}</p>
                </Row.Item>
              </Row>
              <Row>
                <Row.Item>
                  <p>{l10n.getString("payments-label")}</p>
                </Row.Item>
                <Row.Item shrink>
                  <p>{l10n.getString("wire-receipt-payments", {
                        total: totalPayments,
                      })}</p>
                </Row.Item>
              </Row>
            </ResponsiveFlex>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              label={l10n.getString("label-done")}
              testId="wire-import-receipt-done-button"
              onClick={handleClickDone}
            />
            <Button
              kind="plain"
              label={l10n.getString("ach-payment-receipt-cta")}
              testId="wire-import-receipt-cta-button"
              onClick={handleClickCTA}
            />
          </div>
        </div>
      </ContentCard>
    </div>
  );
};

export default WireReceiptScreen;
